export enum TipoDocumento {
  CPF = 'CPF',
  ESTRANGEIRO = 'ESTRANGEIRO'
}
